const state = {
    lastActive: null,
    idleTimeout: process.env.VUE_APP_IDLE_CHECK_INTERVAL * 60 * 1000, //15 minutes screen inactivity timeout
}
const mutations = {
    setLastActive(state, timestamp) {
        state.lastActive = timestamp;
    },
}
const actions = {
    setLastActive({ commit }, timestamp) {
        commit('setLastActive', timestamp);
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}